module.exports = __webpack_public_path__ + "static/media/evakueeru.bd1ee093.svg";